import React from 'react';
import CaseFetch from '../../components/CaseForm/CaseFetch';

function CaseView(props) {
  return <CaseFetch {...props} />;
}

export default CaseView;
